import { MethodsInput } from "../../types/model/methodsInput";

export const MODEL_DEFAULTS = {
  kaq: 1,
  npor: 0.3,
  z: null,
  hstar: null,
} as const;

export const CAPTURE_ZONE_DEFAULTS = {
  nt: 10,
  zstart: null,
  hstepmax: 10,
  vstepfrac: 0.2,
  nstepmax: 100,
} as const;

export const placeholderOf = (v: number | null) =>
  v === null ? "null" : String(v);

export const getFlow = (mi?: MethodsInput) => mi?.flowM3Day;

export const hasValidFlow = (v: unknown): v is number =>
  typeof v === "number" && Number.isFinite(v) && v > 0;

export const isEmptyNumber = (v: unknown) =>
  v === undefined || v === null || Number.isNaN(v);

export interface UsedWell {
  captureId: number;
  inputId: number;
  rw?: number | null;
  res?: number | null;
}

export type SaveInputFlow = (
  captureId: number,
  inputId: number,
  flow: number,
) => Promise<void>;

export type CreateInputWithFlow = (
  captureId: number,
  flow: number,
) => Promise<MethodsInput>;